import { requisitarAuditoria } from "../prontuario-auditoria";
import { requisitarFavoritos } from "../prontuario-favoritos";
import { consultarPdfHistorico } from "../prontuario-history-media";
import { requisitarGravacaoTexto } from "../prontuario-text-save";
import { requisitarAcaoHistorico } from "../prontuario-history-actions";
import { lerHistorico } from "../prontuario-history-readings";
import { enviarOperacaoLaudo } from "../prontuario-laudo-operations";
import { consultarEditorTexto } from "../prontuario-text-editor";
import { requisitarAbertura } from "../prontuario-opening";
import { consultarFichas } from "../prontuario-forms";
import { consultarHistorico } from "../prontuario-history";
import { respostaAtendimentoValida, erroGravacao, salvarDetalhesConfirmados } from "../prontuario-save";
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {
    entrarAtendendo: false, 
    imagensIncluindo: [], 
    cidIncluindo: [], 
    medicamentosIncluindo: [], 
    textosIncluindo: [], 
    agendasRetornoIncluindo: [], 
    historicosIncluindo: [], 
    solicitacoesProcedimentosIncluindo: [], 
    arquetiposIncluindo: [], 
    infoTissIncluindo: {
        TISS_INDICADOR_ACIDENTE: "",
        TISS_TIPO_DOENCA: "",
        TISS_TEMPO_DOENCA_TIPO: "",
        TISS_TIPO_SAIDA: "",
        TISS_INDICACAO_CLINICA: "",
        TISS_LAUDO_ESPECIAL: "",
        TISS_LAUDO_PRORROGACAO: "",
        TISS_TIPO_ATENDIMENTO: "",
        TISS_TEMPO_DOENCA: "",
        TISS_OBSERVACAO: "",
        ALTERANDO: false
    }, 
    idLogLaudoExibir: "", 
    imprimirLaudoDireto: false, 
    refazTextoLaudo: false, 
    salvarTextoDiretamente: false, 
    filtrarDiretamenteAtendimento: "", 
    enviandoImagensPepTimeline: false, 
    liberarLaudoAposIniciar: false, 
    autosavingAtendimentos: false,
    documentsSignPending: [],
    assinaturasImediatas: [],
    versaoPendenciasAssinatura: 0
};

const getters = {
    entrarAtendendo(state) {
        return state.entrarAtendendo;
    },
    imagensIncluindo(state) {
        return state.imagensIncluindo;
    },
    cidIncluindo(state) {
        return state.cidIncluindo;
    },
    medicamentosIncluindo(state) {
        return state.medicamentosIncluindo;
    },
    textosIncluindo(state) {
        return state.textosIncluindo;
    },
    agendasRetornoIncluindo(state) {
        return state.agendasRetornoIncluindo;
    },
    historicosIncluindo(state) {
        return state.historicosIncluindo;
    },
    solicitacoesProcedimentosIncluindo(state) {
        return state.solicitacoesProcedimentosIncluindo;
    },
    arquetiposIncluindo(state) {
        return state.arquetiposIncluindo;
    },
    infoTissIncluindo(state) {
        return state.infoTissIncluindo;
    },
    idLogLaudoExibir(state) {
        return state.idLogLaudoExibir;
    },
    imprimirLaudoDireto(state) {
        return state.imprimirLaudoDireto;
    },
    refazTextoLaudo(state) {
        return state.refazTextoLaudo;
    },
    salvarTextoDiretamente(state) {
        return state.salvarTextoDiretamente;
    },
    filtrarDiretamenteAtendimento(state) {
        return state.filtrarDiretamenteAtendimento;
    }, 
    enviandoImagensPepTimeline(state) {
        return state.enviandoImagensPepTimeline;
    }, 
    liberarLaudoAposIniciar(state) {
        return state.liberarLaudoAposIniciar;
    }, 
    autosavingAtendimentos(state) {
        return state.autosavingAtendimentos;
    }, 
    documentsSignPending(state) {
        return state.documentsSignPending.filter(item => !state.assinaturasImediatas.includes(String(item.ID_PACIENTE_LAUDO)));
    }
};

const mutations = {
    definirAssinaturaImediata(state, { id, ativa, concluida }) {
        const chave = String(id);
        state.versaoPendenciasAssinatura++;
        state.assinaturasImediatas = state.assinaturasImediatas.filter(item => item !== chave);
        if(ativa) { state.assinaturasImediatas.push(chave); }
        if(concluida) { state.documentsSignPending = state.documentsSignPending.filter(item => String(item.ID_PACIENTE_LAUDO) !== chave); }
    },
    updateEntrarAtendendo(store, entrarAtendendo) {
        store.entrarAtendendo = entrarAtendendo;
    },
    updateImagensIncluindo(store, imagensIncluindo) {
        store.imagensIncluindo = imagensIncluindo;
    },
    updateCidIncluindo(store, cidIncluindo) {
        store.cidIncluindo = cidIncluindo;
    },
    updateMedicamentosIncluindo(store, medicamentosIncluindo) {
        store.medicamentosIncluindo = medicamentosIncluindo;
    },
    updateTextosIncluindo(store, textosIncluindo) {
        store.textosIncluindo = textosIncluindo;
    },
    updateAgendasRetornoIncluindo(store, agendasRetornoIncluindo) {
        store.agendasRetornoIncluindo = agendasRetornoIncluindo;
    },
    updateHistoricosIncluindo(store, historicosIncluindo) {
        store.historicosIncluindo = historicosIncluindo;
    },
    updateSolicitacoesProcedimentosIncluindo(store, solicitacoesProcedimentosIncluindo) {
        store.solicitacoesProcedimentosIncluindo = solicitacoesProcedimentosIncluindo;
    },
    updateArquetiposIncluindo(store, arquetiposIncluindo) {
        store.arquetiposIncluindo = arquetiposIncluindo;
    },
    updateInfoTissIncluindo(store, infoTissIncluindo) {
        store.infoTissIncluindo = infoTissIncluindo;
    },
    updateIdLogLaudoExibir(store, idLogLaudoExibir) {
        store.idLogLaudoExibir = idLogLaudoExibir;
    },
    updateImprimirLaudoDireto(store, imprimirLaudoDireto) {
        store.imprimirLaudoDireto = imprimirLaudoDireto;
    },
    updateRefazTextoLaudo(store, refazTextoLaudo) {
        store.refazTextoLaudo = refazTextoLaudo;
    },
    updateSalvarTextoDiretamente(store, salvarTextoDiretamente) {
        store.salvarTextoDiretamente = salvarTextoDiretamente;
    },
    updateFiltrarDiretamenteAtendimento(store, filtrarDiretamenteAtendimento) {
        store.filtrarDiretamenteAtendimento = filtrarDiretamenteAtendimento;
    }, 
    updateEnviandoImagensPepTimeline(store, enviandoImagensPepTimeline) {
        store.enviandoImagensPepTimeline = enviandoImagensPepTimeline;
    }, 
    updateLiberarLaudoAposIniciar(store, liberarLaudoAposIniciar) {
        store.liberarLaudoAposIniciar = liberarLaudoAposIniciar;
    },
    updateAutosavingAtendimentos(store, autosavingAtendimentos) {
        store.autosavingAtendimentos = autosavingAtendimentos;
    }, 
    updateDocumentsSignPending(store, documentsSignPending) {
        documentsSignPending.forEach((documentSignPendingItem) => {
            let indice = -1;

            store.documentsSignPending.forEach((documentSignPending, index) => {
                if(documentSignPending.ID_PACIENTE_LAUDO == documentSignPendingItem.ID_PACIENTE_LAUDO) {
                    indice = index;
                }
            });
            
            if(indice == -1) {
                store.documentsSignPending.push(documentSignPendingItem);
            }
        });

        for(let index = store.documentsSignPending.length - 1; index >= 0; index--) {
            let indice = -1;

            documentsSignPending.forEach((documentSignPendingItem, index2) => {
                if(store.documentsSignPending[index].ID_PACIENTE_LAUDO == documentSignPendingItem.ID_PACIENTE_LAUDO) {
                    indice = index2;
                }
            });
            
            if(indice == -1) {
                store.documentsSignPending.splice(index, 1);
            }
        }
    }, 
    updateDocumentSigning(store, idPacienteLaudo) {
        for(let index = 0; index < store.documentsSignPending.length; index++) {
            if(store.documentsSignPending[index].ID_PACIENTE_LAUDO == idPacienteLaudo) {
                if(typeof store.documentsSignPending[index].signing == undefined) {
                    store.documentsSignPending[index].signing = true;
                } else {
                    store.documentsSignPending[index].signing = !store.documentsSignPending[index].signing;
                }
            }
        }
    }, 
    updateDocumentDiscarding(store, idPacienteLaudo) {
        for(let index = 0; index < store.documentsSignPending.length; index++) {
            if(store.documentsSignPending[index].ID_PACIENTE_LAUDO == idPacienteLaudo) {
                if(typeof store.documentsSignPending[index].discarding == undefined) {
                    store.documentsSignPending[index].discarding = true;
                } else {
                    store.documentsSignPending[index].discarding = !store.documentsSignPending[index].discarding;
                }
            }
        }
    }
};

const actions = {
    requisitarAuditoria(context, pedido) { return requisitarAuditoria(ApiService, JwtService, pedido); },
    requisitarFavoritos(context, pedido) { return requisitarFavoritos(ApiService, JwtService, pedido); },
    consultarPdfHistorico(context, pedido) { return consultarPdfHistorico(ApiService, JwtService, pedido); },
    definirAssinaturaImediata(context, dados) { context.commit("definirAssinaturaImediata", dados); },
    enviarOperacaoLaudo(context, dados) {
        return enviarOperacaoLaudo(ApiService, JwtService, dados);
    },
    consultarLeituraEditorTexto(context, dados) {
        return consultarEditorTexto(ApiService, JwtService, dados);
    },
    atualizarEntrarAtendendo(context, entrarAtendendo) {
        context.commit("updateEntrarAtendendo", entrarAtendendo);
    },
    atualizarImagensIncluindo(context, imagensIncluindo) {
        context.commit("updateImagensIncluindo", imagensIncluindo);
    },
    atualizarCidIncluindo(context, cidIncluindo) {
        context.commit("updateCidIncluindo", cidIncluindo);
    },
    atualizarMedicamentosIncluindo(context, medicamentosIncluindo) {
        context.commit("updateMedicamentosIncluindo", medicamentosIncluindo);
    },
    atualizarTextosIncluindo(context, textosIncluindo) {
        context.commit("updateTextosIncluindo", textosIncluindo);
    },
    atualizarAgendasRetornoIncluindo(context, agendasRetornoIncluindo) {
        context.commit("updateAgendasRetornoIncluindo", agendasRetornoIncluindo);
    },
    atualizarHistoricosIncluindo(context, historicosIncluindo) {
        context.commit("updateHistoricosIncluindo", historicosIncluindo);
    },
    atualizarSolicitacoesProcedimentosIncluindo(context, solicitacoesProcedimentosIncluindo) {
        context.commit("updateSolicitacoesProcedimentosIncluindo", solicitacoesProcedimentosIncluindo);
    },
    atualizarArquetiposIncluindo(context, arquetiposIncluindo) {
        context.commit("updateArquetiposIncluindo", arquetiposIncluindo);
    },
    atualizarInfoTissIncluindo(context, infoTissIncluindo) {
        context.commit("updateInfoTissIncluindo", infoTissIncluindo);
    },
    atualizarIdLogLaudoExibir(context, idLogLaudoExibir) {
        context.commit("updateIdLogLaudoExibir", idLogLaudoExibir);
    },
    atualizarImprimirLaudoDireto(context, imprimirLaudoDireto) {
        context.commit("updateImprimirLaudoDireto", imprimirLaudoDireto);
    },
    atualizarRefazTextoLaudo(context, refazTextoLaudo) {
        context.commit("updateRefazTextoLaudo", refazTextoLaudo);
    },
    atualizarSalvarTextoDiretamente(context, salvarTextoDiretamente) {
        context.commit("updateSalvarTextoDiretamente", salvarTextoDiretamente);
    },
    atualizarFiltrarDiretamenteAtendimento(context, filtrarDiretamenteAtendimento) {
        context.commit("updateFiltrarDiretamenteAtendimento", filtrarDiretamenteAtendimento);
    },
    atualizarEnviandoImagensPepTimeline(context, enviandoImagensPepTimeline) {
        context.commit("updateEnviandoImagensPepTimeline", enviandoImagensPepTimeline);
    },
    atualizarLiberarLaudoAposIniciar(context, liberarLaudoAposIniciar) {
        context.commit("updateLiberarLaudoAposIniciar", liberarLaudoAposIniciar);
    },
    atualizarAutosavingAtendimentos(context, autosavingAtendimentos) {
        context.commit("updateAutosavingAtendimentos", autosavingAtendimentos);
    }, 
    atualizarDocumentsSignPending(context, documentsSignPending) {
        context.commit("updateDocumentsSignPending", documentsSignPending);
    }, 
    atualizarDocumentSigning(context, idPacienteLaudo) {
        context.commit("updateDocumentSigning", idPacienteLaudo);
    }, 
    atualizarDocumentDiscarding(context, idPacienteLaudo) {
        context.commit("updateDocumentDiscarding", idPacienteLaudo);
    }, 
    getPEPEstatisticas(context, filtros) {
        return consultarHistorico(ApiService, JwtService, "listaPEPEstatisticas", filtros);
    },
    getPEPDatas(context, filtros) {
        return consultarHistorico(ApiService, JwtService, "listaPEPDatas", filtros);
    },
    getPEP(context, filtros) {
        return consultarHistorico(ApiService, JwtService, "listaPEP", filtros);
    },
    getAtendimentoDetalhes(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listarAtendimentoDetalhesDados", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getAtendimentosDetalhes(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listarAtendimentosDetalhesDados", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    consultarFichasDoAtendimento(context, dados) {
        return consultarFichas(ApiService, JwtService, "listarFichasDadosMedico", dados);
    },
    consultarCamposDasFichas(context, dados) {
        return consultarFichas(ApiService, JwtService, "listarAtendimentoTipoItens", dados);
    },
    getFichasDadosMedico(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listarFichasDadosMedico", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getAtendimentosTipoItens(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listarAtendimentoTipoItens", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getTitulosFrases(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listarTitulosFrases", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPDF(context, token) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/obterPDF", { TOKEN: token }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getUltimoDocumentoProduto(context, idAgendaExame) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/obterUltimoDocumentoProduto", { ID_AGENDA_EXAME: idAgendaExame }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getDocumento(context, idDiversos) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/obterDocumento", { ID_DIVERSOS: idDiversos }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getCIDMaisUsados(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listar5MaisUsadosPorMedico", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getAtendimentosHoje(context, dados) {
        return requisitarAbertura(ApiService, JwtService, "obterAtendimentosHoje", dados);
    },
    iniciarAtendimentoConfirmado(context, dados) {
        return requisitarAbertura(ApiService, JwtService, "iniciarAtendimento", dados);
    },
    consultarInicioAtendimento(context, dados) {
        return requisitarAbertura(ApiService, JwtService, "consultarInicioAtendimento", dados);
    },
    getCabecalhoRodape(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/obterCabecalhoRodape", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    iniciarAtendimentoServer(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/iniciarAtendimento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async salvarAtendimento(context, detalhes) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para salvar o atendimento."); }
        ApiService.setHeader();
        try {
            const { data } = await ApiService.postOnce("atendimentos/access/salvarAtendimento", detalhes, { timeout: 120000 });
            if(data?.queued === true) { return data; }
            if(!respostaAtendimentoValida(data, detalhes)) {
                throw Object.assign(new Error(), { response: { data } });
            }
            return data;
        } catch(error) {
            throw erroGravacao(error);
        }
    },
    async consultarTextosAtendimento(context, dados) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para consultar o atendimento."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("atendimentos/access/consultarTextosAtendimento", dados, { timeout: 120000 });
        return data;
    },
    async retomarSalvamentoAtendimento(context, dados) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para retomar o atendimento."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("atendimentos/access/retomarSalvamentoAtendimento", dados, { timeout: 120000 });
        return data;
    },
    async autoSalvarAtendimentoDetalhe(context, detalhes) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para salvar a ficha."); }
        ApiService.setHeader();
        return salvarDetalhesConfirmados(ApiService, detalhes);
    },
    async salvarAtendimentoDetalhe(context, detalhes) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para salvar a ficha."); }
        ApiService.setHeader();
        return salvarDetalhesConfirmados(ApiService, detalhes);
    },
    atualizarDiversos(context, diverso) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/atualizarDiversos", diverso).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    excluirDiversos(context, idDiversos) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/excluirDiversos", { ID_DIVERSOS: idDiversos }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async getHistoricos(context, idPaciente) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para consultar o histórico."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("atendimentos/access/buscarHistoricos", { ID_PACIENTE: idPaciente }, { timeout: 120000 });
        if(!Array.isArray(data)) { throw new Error("Resposta inválida do histórico."); }
        return data;
    },
    excluirHistorico(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/excluirHistorico", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    atualizarImagemTitulo(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/atualizarImagemTitulo", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async requisitarRemocaoConfirmada(context, { consultar, dados }) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const endpoint = consultar ? "consultarRemocaoItem" : "removerItemConfirmado";
        const { data } = await ApiService.postOnce("atendimentos/access/" + endpoint, dados, { timeout: 120000 });
        return data;
    },
    async requisitarMedicamentoConfirmado(context, { consultar, dados }) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const endpoint = consultar ? "consultarMedicamentoConfirmado" : "salvarMedicamentoConfirmado";
        const { data } = await ApiService.postOnce("atendimentos/access/" + endpoint, dados, { timeout: 120000 });
        return data;
    },
    salvarMedicamento(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/salvarMedicamento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    removerMedicamento(context, idAtendimentoMedicamento) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/removerMedicamento", {ID_ATENDIMENTOS_MEDICAMENTOS: idAtendimentoMedicamento}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async requisitarSolicitacoesConfirmadas(context, { consultar, dados }) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const endpoint = consultar ? "consultarSolicitacoesConfirmadas" : "salvarSolicitacoesConfirmadas";
        const { data } = await ApiService.postOnce("atendimentos/access/" + endpoint, dados, { timeout: 120000 });
        return data;
    },
    salvarSolicitacaoProcedimento(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/salvarSolicitacaoProcedimento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    removerSolicitacaoProcedimento(context, idSolicitacaoExame) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/removerSolicitacaoProcedimento", {ID_SOLICITACAO_EXAME: idSolicitacaoExame}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    async buscarArquetipos(context, idAgenda) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para consultar os dados do atendimento."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("atendimentos/access/buscarArquetipos", { ID_AGENDA: idAgenda }, { timeout: 120000 });
        if(!Array.isArray(data)) { throw new Error("Resposta inválida ao consultar os dados do atendimento."); }
        return data;
    },
    listarRetornosAtendimento(context, idAtendimento) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listarRetornosAtendimento", {ID_ATENDIMENTO: idAtendimento}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getDiversos(context, idDiversos) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/obterDiversos", {ID_DIVERSOS: idDiversos}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    requisitarGravacaoTexto(context, requisicao) {
        return requisitarGravacaoTexto(ApiService, JwtService, requisicao);
    },
    salvarDiversos(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/salvarDiversos", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    buscarComplementos(context, idAgendaExame) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/buscarComplementos", {ID_AGENDA_EXAME: idAgendaExame}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    salvarComplemento(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/salvarComplemento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    excluirComplemento(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/excluirComplemento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    listarPendencias(context, idDiversos) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listarPendencias", {ID_DIVERSOS: idDiversos}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    obterLaudoPaciente(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/obterLaudoPaciente", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    liberarLaudoPaciente(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/liberarLaudoPaciente", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    salvarSolicitarRevisao(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/salvarSolicitarRevisao", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    revisarModelo(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("modelosLaudos/access/revisarModelo", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    validarSenhaCertificado(context, senha) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/validarSenhaCertificado", {SENHA: senha}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    associaPDFLaudoLiberado(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/associaPDFLaudoLiberado", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    downloadLaudoPDF(context, idPacienteLaudo) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/downloadLaudoPDF", {ID_PACIENTE_LAUDO: idPacienteLaudo}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    downloadFichaPDF(context, idAtendimento) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/downloadFichaPDF", {ID_ATENDIMENTO: idAtendimento}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getLogsLaudo(context, idDiversos) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listarLogLaudo", {ID_DIVERSOS: idDiversos}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getLogLaudo(context, idLaudoLog) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/obterLogLaudo", {ID_LAUDO_LOG: idLaudoLog}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    listarAtendimentosSistemas(context, idPaciente) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listarSistemas", {ID_PACIENTE: idPaciente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    excluirSistemaPadrao(context, idAtendimentoSistema) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/excluirSistemaPadrao", {ID_ATENDIMENTO_SISTEMA: idAtendimentoSistema}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    salvarSistemaPadrao(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/salvarSistemaPadrao", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    listarMarcacoes(context, idPaciente) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listarMarcacoes", {ID_PACIENTE: idPaciente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    removerMarcacao(context, idAtendimentoArea) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/removerMarcacao", {ID_ATENDIMENTO_AREA: idAtendimentoArea}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    salvarMarcacao(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/salvarMarcacao", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    async requisitarAcaoHistorico(context, pedido) {
        return requisitarAcaoHistorico(ApiService, JwtService, pedido);
    },
    async lerHistorico(context, pedido) { return lerHistorico(ApiService, JwtService, pedido); },
    alterarAreaItem(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/alterarAreaItem", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    auditarItemAtendimento(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/auditarItemAtendimento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    removerAuditoriaItemAtendimento(context, idAtendimentoAuditoria) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/removerAuditoriaItemAtendimento", {ID_ATENDIMENTO_AUDITORIA: idAtendimentoAuditoria}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getDetalhesAtendimento(context, idAtendimento) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listarDetalhesAtendimento", {ID_ATENDIMENTO: idAtendimento}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getPosologiasBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/listaBoxPosologias", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    verificarAlergiaFarmaco(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/verificarAlergiaFarmaco", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    buscarFichaDadosFavoritos(context, idFichaDadosCampo) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/buscarFichaDadosFavoritos", {ID_FICHA_DADOS_CAMPO: idFichaDadosCampo}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    excluirFichaDadoFavorito(context, idFichaDadosCampoFavorito) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/excluirFichaDadoFavorito", {ID_FICHA_DADOS_CAMPO_FAVORITO: idFichaDadosCampoFavorito}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    salvarFichaDadoFavorito(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/salvarFichaDadoFavorito", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    obterJitsiToken(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/getJitsiToken", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getBloqueioLaudo(context, idDiversos) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/obterBloqueioLaudo", {ID_DIVERSOS: idDiversos}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    desbloquearLaudo(context, idDiversos) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/desbloquearLaudo", {ID_DIVERSOS: idDiversos}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    salvarVideoTeleatendimento(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("teleatendimentos/access/salvarVideoTeleatendimento", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    liberarImagemPaciente(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/liberarImagemPaciente", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    async iniciarAssinatura(context, dados) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("atendimentos/access/iniciarAssinatura", dados, { timeout: 120000 });
        return data;
    }, 
    async completarAssinatura(context, dados) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("atendimentos/access/completarAssinatura", dados, { timeout: 120000 });
        return data;
    }, 
    async prepararAssinaturaConclusao(context, dados) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível para preparar a assinatura."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("atendimentos/access/prepararAssinaturaConclusao", dados, { timeout: 120000 });
        return data;
    },
    gerarPDFDetalheAssinatura(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/gerarPDFDetalheAssinatura", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    iniciarAssinaturaDetalhe(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/iniciarAssinaturaDetalhe", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    completarAssinaturaDetalhe(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/completarAssinaturaDetalhe", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    buscarAssinaturaDetalhe(context, idAtendimento) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/buscarAssinaturaDetalhe", { ID_ATENDIMENTO: idAtendimento }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getAtendimento(context, idAtendimento) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/obter", { ID_ATENDIMENTO: idAtendimento }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    async checkDocumentsSignPending(context) {
        if(!JwtService.getToken()) { return []; }
        const versao = context.state.versaoPendenciasAssinatura;
        ApiService.setHeader();
        const { data } = await ApiService.query("atendimentos/access/listarLaudosPendentesAssinatura", { timeout: 30000 });
        if(!Array.isArray(data)) { throw new Error("Não foi possível consultar as pendências de assinatura."); }
        if(context.state.versaoPendenciasAssinatura === versao) { context.commit("updateDocumentsSignPending", data); }
        return data;
    }, 
    discardDocumentSignPending(context, idPacienteLaudo) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("atendimentos/access/descartarLaudoPendenteAssinatura", { ID_PACIENTE_LAUDO: idPacienteLaudo }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
